/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_AnswerInputs */

const en_us2_profile_answer = /** @type {(inputs: Profile_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer`)
};

const pt_br2_profile_answer = /** @type {(inputs: Profile_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responder`)
};

const es_419_profile_answer = /** @type {(inputs: Profile_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responder`)
};

const pt_pt2_profile_answer = /** @type {(inputs: Profile_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responder`)
};

const fr_fr2_profile_answer = /** @type {(inputs: Profile_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répondre`)
};

const de_de2_profile_answer = /** @type {(inputs: Profile_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antworten`)
};

const it_it2_profile_answer = /** @type {(inputs: Profile_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rispondi`)
};

/**
* | output |
* | --- |
* | "Answer" |
*
* @param {Profile_AnswerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_answer = /** @type {((inputs?: Profile_AnswerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_AnswerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_answer(inputs)
	if (locale === "es-419") return es_419_profile_answer(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_answer(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_answer(inputs)
	if (locale === "de-DE") return de_de2_profile_answer(inputs)
	if (locale === "it-IT") return it_it2_profile_answer(inputs)
	return en_us2_profile_answer(inputs)
});
export { profile_answer as "profile.answer" }